import React from "react";

export const Image = ({ title, smallImage, hundleClick, i }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a  title={title} href="#" onClick={()=>hundleClick(i)}>
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img  style={{width:"100%"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/gallery/thumbs/thumb_${smallImage}`} className="img-responsive" alt={title} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
